import React from "react";

const EduAndExp = () => {
  return (
    <>
      <div className="salv-about-edu-expr">
        <div className="row sal-about-eduction-row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 salv-experience-col">
            <h6 className="salv-about-personla-title mb-0 w-text dark-about-personal-title sm-md-font inter-font-700 mb-0">
              experience
            </h6>
            <div className="about-educ-card-wrap">
              <div className="eduction-card edu-card-one dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">
                    JUL 2025 – JUL 2026 : Lead AI Consultant &amp; Enterprise Architect
                  </div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    Cleartelligence
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <ul>
                    <li>
                      Architected a production conversational AI platform on Snowflake Cortex Analyst with Python tool-calling and structured-output workflows for verified NL-to-SQL over financial data.
                    </li>
                    <li>
                      Designed a dual semantic data-view layer grounding LLM agents in structured Snowflake data for accurate query generation.
                    </li>
                    <li>
                      Built enterprise RAG pipelines (chunking, embedding, hybrid search, cross-encoder reranking) over investment PDFs via Databricks.
                    </li>
                    <li>
                      Established agent evaluation and observability pipelines for hallucination mitigation, latency/token telemetry, and production reliability.
                    </li>
                    <li>
                      Deployed AI services on AWS/Bedrock and Microsoft Azure with FastAPI and React dashboards, cutting model delivery lifecycle time by 25%.
                    </li>
                    <li>
                      Mentored a distributed team of 8 engineers on agentic architecture and MLOps paradigms.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="eduction-card edu-card-one dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">
                    SEP 2023 – JUL 2025 : Lead &amp; Principal AI Engineer
                  </div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    HSBC (PurView Services)
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <ul>
                    <li>
                      Architected a secure on-prem multi-agent chatbot on Llama2, LangChain, and LangGraph with a custom MCP interface to Jira for conversational project analytics.
                    </li>
                    <li>
                      Built enterprise RAG pipelines with hybrid retrieval and cross-encoder reranking over sensitive banking documentation.
                    </li>
                    <li>
                      Implemented agent evaluation, ABAC/RBAC guardrails, and role-aware retrieval integrated with enterprise SSO.
                    </li>
                    <li>
                      Directed React 16→18 modernization of the internal data portal, improving load speed by 50%; led an 8-member engineering team.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="eduction-card edu-card-two dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">APR 2023 – AUG 2023 : Full Stack Developer</div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    SystemSoft
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <ul>
                    <li>
                      Designed AWS-native and Azure-ready AI foundation services (Bedrock, S3, Lambda, REST APIs) for future RAG and agentic initiatives.
                    </li>
                    <li>
                      Led a squad of 8 engineers building Java/Python backends and React front-ends, cutting backend latency by 35%.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="eduction-card edu-card-two dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">OCT 2022 – JAN 2023 : Lead</div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    Callaway Golf
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <ul>
                    <li>
                      Led frontend optimization of SAP Commerce Cloud using React, improving page load speed by 35%.
                    </li>
                    <li>
                      Maintained Python-driven REST API connections between product catalogs and marketing analytics platforms.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="eduction-card edu-card-two dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">JUL 2022 – OCT 2022 : Senior Developer</div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    Infosys (Nithyo Infotech)
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <ul>
                    <li>
                      Architected reusable modules for an enterprise page-builder platform (React, TypeScript, Python), raising automated test coverage above 90%.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="eduction-card edu-card-two dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">DEC 2021 – MAR 2022 : UI Lead</div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    10X Incubator (Cila Labs)
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <ul>
                    <li>
                      Built containerized applications on AWS (Docker, Kubernetes, S3, Bedrock integration patterns) for AI-powered services.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="eduction-card edu-card-two dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">MAY 2021 – NOV 2021 : Web Lead</div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    Indegene
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <p>
                    Led SEO-optimized, regulation-compliant web application delivery for healthcare/pharma clients, improving organic visibility by 20%.
                  </p>
                </div>
              </div>
              <div className="eduction-card edu-card-two dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">
                    OCT 2015 – JAN 2021 : Senior Developer
                  </div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    Skuad
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <p>
                    Built full-stack data-handling systems (React, PHP) and automated enterprise workflows via UiPath RPA, saving 200+ engineering hours monthly; orchestrated AWS↔Azure cloud migrations with IAM-based access control.
                  </p>
                </div>
              </div>
              <div className="eduction-card edu-card-three dark-edu-card">
                <div className="year-edu-className">
                  <div className="educ-year">
                    JUL 2012 – OCT 2015 : Junior Web Designer
                  </div>
                  <p className="about-edu-title sm-md-font w-text inter-font-500 mb-0">
                    Sitosys e-Media Pvt. Ltd
                  </p>
                </div>
                <div className="about-desc sm-font-two inter-font-400 dark-sec-color">
                  <p>
                    Built responsive, SEO-optimized web platforms and custom CMS solutions, establishing the design-to-code discipline that underpins current UI and agent-surface work.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EduAndExp;
